import(/* webpackMode: "eager" */ "/vercel/path0/src/app/sacola/page.tsx");
